




















































































































































































































































































































































































import Vue from 'vue'
import moment from 'moment'

import {
  GetStackWithSispek,
  Sispek,
  Stack,
  PatchSispek,
  SispekParameter,
  SubmitToSispek,
  ViewSispekJSON,
  GetSISPEKRequiredParameters,
  SispekRequiredParameter,
  GetSISPEKChimneysCode,
} from '@/api/cems'

import { TimeZone, FindTimeZone } from '@/api/static'

import JSONViewerDialog from '@/components/json-view-dialog-tabs.vue'

export default Vue.extend({
  name: 'SettingStackSISPEK',
  components: {
    JSONViewerDialog,
  },
  data() {
    return {
      optsFunction: [
        'count',
        'integral',
        'mean',
        'median',
        'mode',
        'sum',
        'min',
        'max',
        'constant',
        'custom',
      ],

      chimenysCode: [] as string[],
      loadingChimneysCode: false,

      optsTimeZone: [] as TimeZone[],
      gettingRequiredParameters: false,
      requiredParams: [] as SispekRequiredParameter[],

      stackUid: '',
      stack: {
        sispek: { average: '5m', schedule: '13 * * * *' } as Sispek,
      } as Stack,
      parameterMap: [] as SispekParameter[],
      deletedParameter: [] as number[],
      formTest: {
        date: moment().format('YYYY-MM-DD'),
        time: new Date().getHours(),
      },
      submitOnProgress: false,
      jsonData: {},
      showJSON: false,
    }
  },
  methods: {
    getStaticData() {
      FindTimeZone()
        .then((tz) => {
          this.optsTimeZone = tz
        })
        .catch(() => {
          //
        })
    },

    async getStackWithSispek() {
      this.stack = await GetStackWithSispek(this.stackUid)
    },

    async patchStack() {
      await PatchSispek(this.stackUid, this.deletedParameter, this.stack)
    },
    async getRequiredParams() {
      this.requiredParams = []
      this.gettingRequiredParameters = true
      setTimeout(() => {
        this.gettingRequiredParameters = false
      }, 5000)

      this.requiredParams = await GetSISPEKRequiredParameters(this.stackUid)
      this.gettingRequiredParameters = false

      for (const par of this.requiredParams) {
        let exist = false
        for (let i = 0; i < this.parameterMap.length; i++) {
          if (this.parameterMap[i].parameter == par.name) {
            exist = true
            break
          }
        }

        if (!exist) {
          this.parameterMap.push({
            parameter: par.name,
            id: 0,
            function: 'mean',
            sispekId: this.stack.sispek?.id || 0,
            source: '',
            valueBroken: 0,
            valueCalibration: 1,
            valueStop: 1,
          })
        }
      }
    },

    async getJSONDataInSISPEKFormat() {
      const measurementTime = moment(
        this.formTest.date + 'T' + this.formTest.time,
        'YYYY-MM-DDTHH'
      ).valueOf()
      this.jsonData = await ViewSispekJSON(this.stackUid, measurementTime)
    },

    getChimneysCode() {
      GetSISPEKChimneysCode()
        .then((codes) => {
          this.chimenysCode = codes
          this.loadingChimneysCode = false
        })
        .catch(() => {
          this.loadingChimneysCode = false
        })
    },

    onFormSubmit(e: Event) {
      e.preventDefault()

      if (this.stack.sispek) {
        this.stack.sispek.parameters = this.parameterMap
      }

      this.patchStack()
      this.deletedParameter = []
    },

    submitParameter() {
      this.submitOnProgress = true
      const measurementTime = moment(
        this.formTest.date + 'T' + this.formTest.time,
        'YYYY-MM-DDTHH'
      ).valueOf()

      SubmitToSispek(this.stackUid, measurementTime)
        .then((res) => {
          if (res.success) {
            this.$toast.success(res.message)
          } else {
            if (res.type && res.type == 'connection') {
              this.$toast.error(res.message, { duration: 10000 })
              return
            }

            if (res.message.length > 64) {
              this.$toast.error(
                'Something went wrong, see console for details.'
              )
              console.log(res.message)
            } else {
              this.$toast.error(res.message)
            }
          }
          this.submitOnProgress = false
        })
        .catch((err) => {
          this.$toast.error('Something wrong.')
          console.log(err)
          this.submitOnProgress = false
        })
    },

    onFormTestSubmit(e: Event) {
      e.preventDefault()
      this.submitParameter()
    },

    addParameterMap() {
      this.parameterMap.push({
        id: 0,
        sispekId: this.stack.sispek?.id || 0,
        function: 'mean',
        source: '',
        parameter: '',
        valueBroken: 0,
        valueCalibration: 1,
        valueStop: 1,
      })
    },

    deleteParameterMap(index: number) {
      const parameterId = this.parameterMap[index].id
      if (parameterId != 0) {
        this.deletedParameter.push(parameterId)
      }

      this.parameterMap.splice(index, 1)
    },
    resetParameterMap() {
      this.parameterMap = JSON.parse(
        JSON.stringify(this.stack.sispek?.parameters || [])
      )
      this.deletedParameter = []
    },
    async showJSONData() {
      await this.getJSONDataInSISPEKFormat()
      this.showJSON = true
    },
  },

  async created() {
    this.getStaticData()
    this.stackUid = this.$route.params.stackUID
    await this.getStackWithSispek()
    this.resetParameterMap()
    this.getChimneysCode()
  },
})
